export default "__VITE_ASSET__3I7NTRQ0__"